import React, { type JSX } from "react";
import Sidebar_Component from "../../Sidebar_Component";
import type { Project } from "../../types/redux";

interface LayoutSidebarsProps {
  isCollapsed: boolean;
  onCollapseToggle: (collapsed: boolean) => void;
  onStartProject: () => void;
  projects: Project[];
  currentProjectId: string | null;
  onProjectClick: (projectId: string) => void;
  projectsLoading: boolean;
  isMobileSidebarOpen: boolean;
  onCloseMobileSidebar: () => void;
}

/** Persistent sidebar on desktop (>=1200px); an overlay everywhere else. */
export default function LayoutSidebars({
  isCollapsed,
  onCollapseToggle,
  onStartProject,
  projects,
  currentProjectId,
  onProjectClick,
  projectsLoading,
  isMobileSidebarOpen,
  onCloseMobileSidebar,
}: LayoutSidebarsProps): JSX.Element {
  return (
    <>
      <div className="hidden desktop:block overflow-hidden">
        <Sidebar_Component
          isCollapsed={isCollapsed}
          onCollapseToggle={onCollapseToggle}
          onStartProject={onStartProject}
          projects={projects}
          currentProjectId={currentProjectId}
          onProjectClick={onProjectClick}
          projectsLoading={projectsLoading}
        />
      </div>

      {isMobileSidebarOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 desktop:hidden"
            onClick={onCloseMobileSidebar}
          />
          {/* Sidebar overlay */}
          <div className="fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-300 ease-in-out desktop:hidden shadow-[4px_0_12px_rgba(0,0,0,0.15)]">
            <Sidebar_Component
              isCollapsed={false}
              onClose={onCloseMobileSidebar}
              onStartProject={onStartProject}
              projects={projects}
              currentProjectId={currentProjectId}
              onProjectClick={(projectId) => {
                onCloseMobileSidebar();
                onProjectClick(projectId);
              }}
              projectsLoading={projectsLoading}
            />
          </div>
        </>
      )}
    </>
  );
}
